import React, { useEffect, useState } from "react";

const Team = () => {
  const [lang, setLang] = useState("En");
  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);
  return (
    <div
      class="corpix-team-section .corpix-team-02 section "
      // style="background-image: url(Files/images/bg/team-bg.jpg);"
      style={{
        backgroundImage: "url(team-bg.jpg)",
        backgroundAttachment: "fixed",
      }}
    >
      <div style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}>
        <div class="container">
          <div class="team-wrap">
            <div class="text-center top-text">
              <h1 style={{ fontSize: "48px", paddingTop: "50px" }}>
                <span>{lang === "Fr" ? `NOTRE` : `Our`}</span>{" "}
                {lang === "Fr" ? `ÉQUIPE` : `Team`}
              </h1>
              <h4>{lang === "Fr" ? `ON RESTE EN CONTACT` : `Keep in touch`}</h4>
            </div>

            <div class="divider text-center">
              <span class="outer-line"></span>
              <span class="fa fa-users" aria-hidden="true"></span>
              <span class="outer-line"></span>
            </div>
            <div class="team-content-wrap">
              <div class="swiper-container team-active">
                <div
                  class="swiper-wrapper team-cards"
                  style={{ justifyContent: "space-evenly" }}
                >
                  <div
                    data-aos="fade-right"
                    data-aos-offset="300"
                    data-aos-easing="ease-in-sine"
                  >
                    <div class="single-team">
                      <div class="team-img">
                        <a>
                          <img src="sidi2.jpg" alt="" />
                        </a>
                      </div>
                      <div class="team-content">
                        <div class="team-social">
                          <ul class="social">
                            <li>
                              <a href="#">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                            {/* <li>
                                                        <a href="#">
                                                            <i class="fab fa-dribbble"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <i class="fab fa-behance"></i>
                                                        </a>
                                                    </li> */}
                          </ul>
                        </div>
                        <h3 class="name">
                          <a>Sidi Shahid</a>
                        </h3>
                        <p class="designation">
                          {lang === "Fr" ? `PDG & Fondateur` : `CEO & Founder`}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    data-aos="fade-left"
                    data-aos-offset="300"
                    data-aos-easing="ease-in-sine"
                  >
                    <div class="single-team">
                      <div class="team-img">
                        <a>
                          <img src="ron2.jpg" alt="" />
                        </a>
                      </div>
                      <div class="team-content">
                        <div class="team-social">
                          <ul class="social">
                            <li>
                              <a href="#">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                            {/* <li>
                                                        <a href="#">
                                                            <i class="fab fa-dribbble"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <i class="fab fa-behance"></i>
                                                        </a>
                                                    </li> */}
                          </ul>
                        </div>
                        <h3 class="name">
                          <a>Ron Monat</a>
                        </h3>
                        <p class="designation">
                          {lang === "Fr"
                            ? `Directeur des États-Unis
d’Amérique`
                            : `Director of United States of
                                                    America`}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    data-aos="fade-left"
                    data-aos-offset="300"
                    data-aos-easing="ease-in-sine"
                  >
                    <div class="single-team">
                      <div class="team-img">
                        <a>
                          <img
                            src={require("../../Assets/ibrahima.png")}
                            alt=""
                          />
                        </a>
                      </div>
                      <div class="team-content">
                        <div class="team-social">
                          <ul class="social">
                            <li>
                              <a href="#">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <i class="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <h3 class="name">
                          <a>Ibrahima Traore</a>
                        </h3>
                        <p class="designation">
                          {lang === "Fr"
                            ? `Directeur d'Afrique`
                            : `Director of Africa`}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "55px" }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
